export default __webpack_public_path__ + "static/studio-2-2-51d6c52864d5971271707cc8685d50dd.jpg";